import { useQuery } from "@tanstack/react-query";
import { getOtpReports, downloadOtpReport } from "../../service/query/auth";


// GET ALL OTP REPORT 
export const useGetOtpReport = ({ payload, page }) => {
  const getOtpReport= useQuery({
    queryKey: ['otp_report', payload, page],
    queryFn: () => getOtpReports({ ...payload, page }),
    enabled: !!payload && !!page,
    keepPreviousData: true,
  },
);

  return {data:getOtpReport?.data?.data,  ...getOtpReport,}
  
};

//DOWNLOAD OTP REPORT 
export const useDownloadOtpReport=({ payload, page }) => {
  const downloadReport= useQuery({
    queryKey: ['otp_report_download', payload, page],
    queryFn: () => downloadOtpReport({ ...payload}),
    enabled: !!payload,
    keepPreviousData: true,
  },
);
 return {data:downloadReport?.data?.data,  ...downloadReport,}
};